import type { ChangeSubscriptionPlan200NewSubscription } from './changeSubscriptionPlan200NewSubscription';

export type ChangeSubscriptionPlan200 = {
  message?: string;
  newSubscription?: ChangeSubscriptionPlan200NewSubscription;
  success?: boolean;
};
